<template>
	<div class="d-flex align-center">
		<button
			class="create-btn"
			v-if="(checkPermissions(['end_tasks']) || ( isMyTask && $store.consultasStore.state.currentTarea.private ))"
			@click="startCloseTasks"
		>
			Finalizar Tarea
		</button>
		<div>
			<ApprovalChecks
				:item="task"
				item_type="task"
				position="bottom-left"
				:roles_needed="requiredRoles"
				v-if="task && itemAprovalCheck"
				@onChange="reloadInfo"/>
		</div>
	</div>
</template>

<script>
import ApprovalChecks from '@/components/Globals/Helpers/ApprovalChecks'

export default {
	name: 'TaskClosure',
	components: {
		ApprovalChecks
	},
	props: {
		task: {
			type: Object,
			required: true
		}
	},
	computed: {
		isMyTask(){
      return this.task.created_by == this.$store.userStore.state.userInfo.id
		},
		availableProfiles() {
			const creator = { id: -1, name: 'Creador',       description: 'Creador del ítem' }
			const responsible = { id: -2, name: 'Responsable', description: 'Responsable del ítem' }
			return [creator, responsible, ...this.$store.projectsStore.state.projectProfiles]
		},
    selectedProject() {
      return this.$store.projectsStore.state.selectedProject
    },
		itemAprovalCheck() {
			return this.selectedProject.closure_config.find(config => config.item_type === 2 && config.use_advanced_closure)
		},
		requiredRoles() {
			if(this.task.closure_config) return this.task.closure_config.advanced_closure_profiles
			return this.itemAprovalCheck ? this.itemAprovalCheck.advanced_closure_profiles : []
		},
		approvalChecks(){
			return this.task.approval_checks
		},
		checkApprovalChecks(){
			if(!this.itemAprovalCheck) return true
			
			const createdBy = this.task.created_by
			const responsable = this.task.responsable

			return this.requiredRoles.every(roleId => {
				if (roleId === -1) {
					return this.approvalChecks.some(item => item.user_id === createdBy)
				}
				if (roleId === -2) {
					return this.approvalChecks.some(item => item.user_id === responsable)
				}
				return this.approvalChecks.some(item => item.job_type === roleId)
			})
		}
	},
	mounted() {
	},
	methods: {
		startCloseTasks() {
			this.$emit('startCloseTasks')
		},
		reloadInfo() {
			this.$emit('reloadInfo')
		}
	}
}
</script>

<style scoped>
.create-btn {
  display: inline-flex; align-items: center; gap: 5px;
  background: #2D4B95; color: white; border: none; cursor: pointer;
  border-radius: 8px; padding: 6px 12px; font-size: 12px; font-weight: 600;
  transition: background 0.15s;
}
.create-btn:hover { background: #243d7a; }
</style>